import { Upload, Trash2, Folder } from 'lucide-react';

const MediaManager = () => {
  const folders = ['Banners', 'Products', 'Team', 'About', 'Applications'];
  const images = [1, 2, 3, 4, 5, 6, 7, 8]; // Mock data

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Media Manager</h1>
        <button className="bg-orange-600 text-white px-4 py-2 rounded flex items-center hover:bg-orange-700 transition-colors">
          <Upload size={18} className="mr-2" /> Upload Image
        </button>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Folders */}
        <div className="w-full md:w-64 bg-white p-4 rounded-lg shadow-sm border border-slate-100 h-fit">
          <h3 className="font-bold text-slate-900 mb-4 px-2">Folders</h3>
          <ul className="space-y-1">
            <li className="bg-orange-50 text-orange-700 px-3 py-2 rounded cursor-pointer font-medium flex items-center">
              <Folder size={18} className="mr-2" /> All Media
            </li>
            {folders.map((folder) => (
              <li key={folder} className="text-slate-600 hover:bg-slate-50 px-3 py-2 rounded cursor-pointer flex items-center transition-colors">
                <Folder size={18} className="mr-2 text-slate-400" /> {folder}
              </li>
            ))}
          </ul>
        </div>

        {/* Grid */}
        <div className="flex-1 bg-white p-6 rounded-lg shadow-sm border border-slate-100">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {images.map((i) => (
              <div key={i} className="group relative aspect-square bg-slate-100 rounded-lg overflow-hidden border border-slate-200">
                <div className="absolute inset-0 flex items-center justify-center text-slate-400">
                  Image {i}
                </div>
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                  <button className="bg-white text-red-600 p-2 rounded-full hover:bg-red-50 transition-colors" title="Delete">
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaManager;
